import { useContext, useEffect, useState, useCallback } from "react";
import { UNSAFE_NavigationContext } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

export default function LeavePageGuard({ when }) {
  const { navigator } = useContext(UNSAFE_NavigationContext);
  const [pendingTx, setPendingTx] = useState(null);

  useEffect(() => {
    if (!when) {
      setPendingTx(null);
      return undefined;
    }

    const originalPush = navigator.push;
    const originalReplace = navigator.replace;

    navigator.push = (...args) => {
      setPendingTx({
        retry() {
          navigator.push = originalPush;
          navigator.replace = originalReplace;
          originalPush(...args);
        },
      });
    };

    navigator.replace = (...args) => {
      setPendingTx({
        retry() {
          navigator.push = originalPush;
          navigator.replace = originalReplace;
          originalReplace(...args);
        },
      });
    };

    return () => {
      navigator.push = originalPush;
      navigator.replace = originalReplace;
    };
  }, [navigator, when]);

  useEffect(() => {
    if (!when) return undefined;
    const handler = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [when]);

  return (
    <Dialog
      open={!!pendingTx}
      onClose={() => setPendingTx(null)}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>Leave this page?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to leave? The swap is still in progress and
          unsaved data will be lost.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={() => setPendingTx(null)}
          variant="contained"
          autoFocus
        >
          Stay on page
        </Button>
        <Button onClick={() => pendingTx?.retry()} color="error">
          Leave page
        </Button>
      </DialogActions>
    </Dialog>
  );
}
